import React, { useState, useRef, useEffect } from 'react';
import '../styles/ContactForms.css';
import '../styles/BannersDash.css';
import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import axios from 'axios';
import config from '../../../constants/config';
import { RiFileShield2Line, RiCheckFill, RiCloseFill } from 'react-icons/ri';
import { useSlideout } from '../../../hooks/SlideoutContext';
import { IoMdRefresh } from 'react-icons/io';

export default function ContactForms() {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const { openSlideout, closeSlideout } = useSlideout();
    
    useEffect(() => {
        fetchForms();
    }, []);

    const fetchForms = () => {
        setLoading(true);

        axios.post(config.api.url + 'admin/forms/fetch', {}, {
            crossdomain: true,
            headers: {
                'api': config.api.key,
                'auth': 'b8GjLbLHDX9isF10ptWj',
            }
        })
        .then((json) => {
            const { success, response, data } = json.data;

            if(success){
                setForms(data);
            } else {
                console.log(response);
            }
            setLoading(false);
        })
        .catch(function (error) {
            console.error("Fetch error:", error);
            setLoading(false);
        });
    };
    
    const ViewForm = ({ form }) => {
        return (
            <div className="EditBannerContainer">
                <div className="EditBannerOptions">
                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Name</div>
                        <div className="EditBannerOptionContent">
                            <div className="FormDetailValue">{form.name}</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Email</div>
                        <div className="EditBannerOptionContent">
                            <div className="FormDetailValue">{form.email}</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Phone</div>
                        <div className="EditBannerOptionContent">
                            <div className="FormDetailValue">{form.phone}</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Message</div>
                        <div className="EditBannerOptionContent">
                            <div className="FormDetailValue MessageContent">{form.message}</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Date Submitted</div>
                        <div className="EditBannerOptionContent">
                            <div className="FormDetailValue">{form.date_created}</div>
                        </div>
                    </div>

                    <div className="EditBannerActions">
                        <button 
                            className="EditBannerSaveButton" 
                            onClick={closeSlideout}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='BannersDash'>
            <div className='BannersHeader'>
                <div className='BannersHeaderTitle'>
                    <h1>Contact Forms</h1>
                    <p>An overview of all the contact form submissions</p>
                </div>
                <div className='BannersHeaderActions'>
                    <button className='BannersRefreshButton' onClick={fetchForms}>
                        <IoMdRefresh />
                        <span>Refresh</span>
                    </button>
                </div>
            </div>

            <div className='BannersContent'>
                <div className='BannersContentNavigation'>
                    <div className='BannersContentNavigationItem Title'>Name</div>
                    <div className='BannersContentNavigationItem Subtitle'>Email</div>
                    <div className='BannersContentNavigationItem Subtitle'>Phone</div>
                    <div className='BannersContentNavigationItem Subtitle'>Date</div>
                </div>
                <div className='BannersScroll'>
                    {forms.map((form, index) => {
                        return (
                            <div className='BannerItem' key={index}>
                                <div className="BannerItemDetailsText First Title Bold">{form.name}</div>
                                <div className="BannerItemDetailsText Subtitle">{form.email}</div>
                                <div className="BannerItemDetailsText Subtitle">{form.phone}</div>
                                <div className="BannerItemDetailsText Subtitle">{form.date_created}</div>

                                <div className="BannerItemOptions">
                                    <a 
                                        onClick={() => {
                                            openSlideout({
                                                title: 'View Form Submission',
                                                content: <ViewForm form={form}/>
                                            });
                                        }} 
                                        className="BannerItemOptionsButton Edit"
                                    >
                                        <RiFileShield2Line style={{ fontSize: 14 }} />
                                        <span className="BannerItemOptionsButtonText">View</span>
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='BannersPaginationWrapper'>
                    {/* Pagination will be added here when needed */}
                </div>
            </div>
        </div>
    )
}
